/* eslint-disable react/prefer-es6-class, react/prop-types, react/sort-comp */
import React from 'react';
import classnames from 'classnames';
import { JAStudyModes } from 'es6/models/user-settings';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';

export const KanaPanel = React.createClass({
  displayName: 'KanaPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return t('js_iknow.japanese study mode');
    },
  },

  /**
   * @params {String} jaStudyMode
   */
  _handleChange(jaStudyMode) {
    const attrs = {
      apps: {
        jaStudyMode,
      },
    };

    this.props.onDataChange.call(null, attrs);
  },

  render() {
    const className = classnames('content-columns', { disabled: this.props.inSession });

    return (
      <div className="kana-mode-settings">
        <div className={className}>
          {this._renderColumn(
            JAStudyModes.DEFAULT,
            'full',
            t('full'),
            t('full-mode-description')
          )}
          {this._renderColumn(
            JAStudyModes.KANA,
            'kana',
            t('js_iknow.kana'),
            t('kana-mode-description')
          )}
          {this._renderColumn(
            JAStudyModes.ROMAJI,
            'romaji',
            t('romaji'),
            t('romaji-mode-description')
          )}
        </div>
      </div>
    );
  },

  /**
   * Renders a column.
   *
   * @param {Number} value    the actual value of the radio box.
   * @param {String} [full|kana|romaji] name
   * @param {String} title
   * @param {String} description
   */
  _renderColumn(value, name, title, description) {
    const id = `ja-study-mode-${name}`;
    const isChecked = this.props.userSettings.apps.jaStudyMode === value;
    const onChange = this._handleChange.bind(null, value);

    return (
      <p className="content-column">
        <input type="radio" id={id} disabled={this.props.inSession} name="ja-study-mode" checked={isChecked} value={value} onChange={onChange} />
        <label htmlFor={id}>
          <span className="title">{title}</span>
          <span className="description">{description}</span>
        </label>
      </p>
    );
  },
});

export default KanaPanel;
